import { render } from "./NotificationForTopPage.vue?vue&type=template&id=316ca308&scoped=true"
import script from "./NotificationForTopPage.vue?vue&type=script&lang=js"
export * from "./NotificationForTopPage.vue?vue&type=script&lang=js"

import "./NotificationForTopPage.vue?vue&type=style&index=0&id=316ca308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316ca308"]])

export default __exports__